import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-slider', {
    month: {
        1: 'месяц',
        2: 'месяца',
        5: 'месяцев',
    },
    year: {
        1: 'год',
        2: 'года',
        5: 'лет',
    },
    value: 'Значение',
});
